import { Injectable } from '@angular/core';
import { RailingMaterialService } from './railing/services/railing-material.service';
import { DataForDisplayingMenuItemsService } from './data-for-displaying-menu-items.service';
import { RailingColorsService } from './railing/services/railing-colors.service';

declare var THREE: any;

@Injectable()
export class VerticalPicketService {
  private _verticalPickets = [
    {
      name: 'Stainless Steel (tubular)',
      shapeType: 'Tubular',
      color: '#DADADA',
      colorName: 'Stainless'
    },
    {
      name: 'Silver Aluminum (square)',
      shapeType: 'Square',
      color: '#B4BABB',
      colorName: 'Silver'
    },
    {
      name: 'White Aluminum (square)',
      shapeType: 'Square',
      color: '#FFFFFF',
      colorName: 'White'
    },
    {
      name: 'Black Aluminum (square)',
      shapeType: 'Square',
      color: '#242424',
      colorName: 'Black'
    }
  ];

  constructor(
    private railingMaterialService: RailingMaterialService,
    private dataForMenu: DataForDisplayingMenuItemsService,
    private railingColorsService: RailingColorsService
  ) {}

  get verticalPickets() {
    return this._verticalPickets;
  }

  setVerticalPicketColor(
    verticalPicketObj: any,
    shapeType: 'Tubular' | 'Sqare',
    colorName: string,
    typeToColor: string
  ) {
    if (shapeType !== 'Tubular' && this.dataForMenu.getCurrentParams().railingType === 'Wood') {
      this.railingColorsService.addProductType.next({
        productType: verticalPicketObj.userData.entity.productType,
        colorType: typeToColor
      });

      const railingType = this.dataForMenu.currentChoises.railingType;
      const verticalPicket = this._verticalPickets.find(
        vp => vp.shapeType === shapeType && vp.colorName === colorName
      );
      for (let j = 0; j < verticalPicketObj.children.length; j++) {
        const child = verticalPicketObj.children[j];
        child.material.color = new THREE.Color(verticalPicket.color || 0xffffff);
        child.material.needsUpdate = true;
        this.railingMaterialService.configMaterial(child, typeToColor, railingType, null);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/vertical-picket.service.ts